import PropertyDataLeftSection from './PropertyDataLeftSection';

export default PropertyDataLeftSection;
